webpackJsonp([2],{

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__firebase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repository_firebase__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__repository_firebase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menuData__ = __webpack_require__(95);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__menuData__["a"]; });




/***/ }),

/***/ 388:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(746),
  /* scopeId */
  "data-v-de3aa8c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_icons_css_material_icons_css__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_icons_css_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_icons_css_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Nav__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Nav__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme('default', {
  primary: 'blue'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#nav',
  template: '<Nav/>',
  components: { Nav: __WEBPACK_IMPORTED_MODULE_4__Nav___default.a }
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_json_editor__ = __webpack_require__(26);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nav',
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__components_json_editor__["a" /* authentication */].retrieveCurrentUser();

            case 3:
              _context.next = 7;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

            case 7:
              _this.isSignIn = __WEBPACK_IMPORTED_MODULE_2__components_json_editor__["a" /* authentication */].currentUser !== null;
              __WEBPACK_IMPORTED_MODULE_2__components_json_editor__["a" /* authentication */].addListener(_this.authChanged);
              _this.$root.$on('accountStatus', function () {
                _this.isSignIn = __WEBPACK_IMPORTED_MODULE_2__components_json_editor__["a" /* authentication */].currentUser !== null;
              });

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 5]]);
    }))();
  },
  data: function data() {
    return {
      isSignIn: false,
      active: 'active'
    };
  },

  methods: {
    authChanged: function authChanged(user) {
      this.isSignIn = user !== null;
    },
    isPath: function isPath(path) {
      return window.location.pathname === path;
    },
    home: function home() {
      if (this.isSignIn) {
        window.location.href = '/editor.html';
      } else {
        window.location.href = '/index.html';
      }
    },
    about: function about() {
      window.location.href = '/index.html';
    },
    guide: function guide() {
      window.location.href = '/guide.html';
    },
    editor: function editor() {
      window.location.href = '/editor.html';
    },
    github: function github() {
      window.open('https://github.com/tangram-js/json-editor', '_blank');
    },
    signIn: function signIn() {
      window.location.href = '/editor.html#/signIn';
    },
    signUp: function signUp() {
      window.location.href = '/editor.html#/signUp';
    },
    changePassword: function changePassword() {
      window.location.href = '/editor.html#/changePassword';
    },
    signOut: function signOut() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__components_json_editor__["a" /* authentication */].signOut();

              case 3:
                _context2.next = 7;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2['catch'](0);

              case 7:
                _this2.$nextTick(function () {
                  console.log('reload');
                  window.location.reload();
                });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 5]]);
      }))();
    },
    deleteAccount: function deleteAccount() {
      this.$refs.deleteAccountDialog.open();
    },
    deleteAccountCanceled: function deleteAccountCanceled() {
      this.$refs.deleteAccountDialog.close();
    },
    deleteAccountConfirmed: function deleteAccountConfirmed() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__components_json_editor__["b" /* repository */].deleteAllSchemas();

              case 3:
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__components_json_editor__["a" /* authentication */].deleteUser();

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

              case 9:
                _this3.$refs.deleteAccountDialog.close();
                _this3.$nextTick(function () {
                  window.location.reload();
                });

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    }
  }
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = UserNotSignInError;
/* unused harmony export Authentication */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authentication; });
/* unused harmony export Storage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Database; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);








var config = {
  apiKey: 'AIzaSyD1BLDRwuKdS_R3xOF3hNgYxgJ9HP9lC74',
  authDomain: 'json-schema-editor.firebaseapp.com',
  databaseURL: 'https://json-schema-editor.firebaseio.com',
  projectId: 'json-schema-editor',
  storageBucket: 'json-schema-editor.appspot.com',
  messagingSenderId: '84857119510'
};
__WEBPACK_IMPORTED_MODULE_6_firebase__["initializeApp"](config);

function UserNotSignInError(message) {
  this.name = 'UserNotSignInError';
  this.message = message || 'No sign in user.';
  this.stack = new Error().stack;
}
UserNotSignInError.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(Error.prototype);
UserNotSignInError.prototype.constructor = UserNotSignInError;

var Authentication = function () {
  function Authentication() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Authentication);

    this.service = __WEBPACK_IMPORTED_MODULE_6_firebase__["auth"]();
    this.currentUser = null;
    this.callbacks = [];
    this.service.onAuthStateChanged(function (user) {
      _this.currentUser = user;
      _this.callbacks.forEach(function (callback) {
        callback(user);
      });
    });
    this.options = {
      requireVerifyEmail: false,
      sendVerifyEmailExplicitly: true,
      requireOldPassword: false
    };
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Authentication, [{
    key: 'addListener',
    value: function addListener(callback) {
      this.callbacks.push(callback);
    }
  }, {
    key: 'removeListener',
    value: function removeListener(callback) {
      var idx = this.callbacks.indexOf(callback);
      if (idx >= 0) this.callbacks.splice(idx, 1);
    }
  }, {
    key: 'signUp',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(email, password) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this2.service.createUserWithEmailAndPassword(email, password).then(function (user) {
                    resolve(user);
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function signUp(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return signUp;
    }()
  }, {
    key: 'sendVerificationEmail',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.currentUser) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this3.currentUser.sendEmailVerification().then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 4:
                throw new UserNotSignInError();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendVerificationEmail() {
        return _ref2.apply(this, arguments);
      }

      return sendVerificationEmail;
    }()
  }, {
    key: 'verifyEmail',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(code) {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this4.service.applyActionCode(code).then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function verifyEmail(_x3) {
        return _ref3.apply(this, arguments);
      }

      return verifyEmail;
    }()
  }, {
    key: 'signIn',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(email, password) {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this5.service.signInWithEmailAndPassword(email, password).then(function (user) {
                    resolve(user);
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function signIn(_x4, _x5) {
        return _ref4.apply(this, arguments);
      }

      return signIn;
    }()
  }, {
    key: 'changePassword',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(newPassword) {
        var _this6 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.currentUser) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this6.currentUser.updatePassword(newPassword).then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 4:
                throw new UserNotSignInError();

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function changePassword(_x6) {
        return _ref5.apply(this, arguments);
      }

      return changePassword;
    }()
  }, {
    key: 'resetPassword',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(email) {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this7.service.sendPasswordResetEmail(email).then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function resetPassword(_x7) {
        return _ref6.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: 'confirmPasswordReset',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(code, newPassword) {
        var _this8 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this8.service.confirmPasswordReset(code, newPassword).then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function confirmPasswordReset(_x8, _x9) {
        return _ref7.apply(this, arguments);
      }

      return confirmPasswordReset;
    }()
  }, {
    key: 'deleteUser',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var _this9 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!this.currentUser) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this9.currentUser.delete().then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 4:
                throw new UserNotSignInError();

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deleteUser() {
        return _ref8.apply(this, arguments);
      }

      return deleteUser;
    }()
  }, {
    key: 'signOut',
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var _this10 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this10.service.signOut().then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function signOut() {
        return _ref9.apply(this, arguments);
      }

      return signOut;
    }()
  }, {
    key: 'retrieveCurrentUser',
    value: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _this11 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this11.currentUser = _this11.service.currentUser;
                  if (_this11.currentUser) {
                    resolve(_this11.currentUser);
                  } else {
                    reject(new UserNotSignInError());
                  }
                }));

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function retrieveCurrentUser() {
        return _ref10.apply(this, arguments);
      }

      return retrieveCurrentUser;
    }()
  }]);

  return Authentication;
}();

var authentication = new Authentication();

var Storage = function Storage() {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Storage);

  this.service = __WEBPACK_IMPORTED_MODULE_6_firebase__["storage"]();
};

var Database = function () {
  function Database() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Database);

    this.service = __WEBPACK_IMPORTED_MODULE_6_firebase__["database"]();
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Database, [{
    key: 'readSnapshot',
    value: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(reference) {
        var _this12 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this12.service.ref(reference).orderByKey().once('value').then(function (snapshot) {
                    resolve(snapshot);
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function readSnapshot(_x10) {
        return _ref11.apply(this, arguments);
      }

      return readSnapshot;
    }()
  }, {
    key: 'readValue',
    value: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(reference) {
        var _this13 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this13.service.ref(reference).orderByKey().once('value').then(function (snapshot) {
                    resolve(snapshot.val());
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function readValue(_x11) {
        return _ref12.apply(this, arguments);
      }

      return readValue;
    }()
  }, {
    key: 'list',
    value: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(reference) {
        var _this14 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this14.service.ref(reference).orderByKey().once('value').then(function (snapshot) {
                    var list = [];
                    snapshot.forEach(function (child) {
                      list.push(decodeURIComponent(child.key.replace('%2E', '.')));
                    });
                    resolve(list);
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function list(_x12) {
        return _ref13.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'write',
    value: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(reference, data) {
        var _this15 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this15.service.ref(reference).set(data).then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function write(_x13, _x14) {
        return _ref14.apply(this, arguments);
      }

      return write;
    }()
  }, {
    key: 'delete',
    value: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(reference) {
        var _this16 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this16.service.ref(reference).remove().then(function () {
                    resolve();
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function _delete(_x15) {
        return _ref15.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return Database;
}();

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "nav"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-dense"
  }, [_c('h3', {
    staticClass: "md-title title",
    on: {
      "click": _vm.home
    }
  }, [_vm._v("JSON Editor")]), _vm._v(" "), _c('md-button', {
    class: [_vm.isPath('/index.html') || _vm.isPath('/') ? _vm.active : ''],
    nativeOn: {
      "click": function($event) {
        _vm.about($event)
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('md-button', {
    class: [_vm.isPath('/guide.html') ? _vm.active : ''],
    nativeOn: {
      "click": function($event) {
        _vm.guide($event)
      }
    }
  }, [_vm._v("Guide")]), _vm._v(" "), _c('md-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editor($event)
      }
    }
  }, [_vm._v("Editor")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('md-button', {
    nativeOn: {
      "click": function($event) {
        _vm.github($event)
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "md-iconset": "fa fa-github"
    }
  })], 1), _vm._v(" "), (!_vm.isSignIn) ? _c('md-button', {
    nativeOn: {
      "click": function($event) {
        _vm.signIn($event)
      }
    }
  }, [_vm._v("Sign In")]) : _vm._e(), _vm._v(" "), (!_vm.isSignIn) ? _c('md-button', {
    nativeOn: {
      "click": function($event) {
        _vm.signUp($event)
      }
    }
  }, [_vm._v("Sign Up")]) : _vm._e(), _vm._v(" "), (_vm.isSignIn) ? _c('md-menu', {
    attrs: {
      "md-align-trigger": ""
    }
  }, [_c('md-button', {
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_vm._v("My Account")]), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.signOut($event)
      }
    }
  }, [_vm._v("Sign Out")]), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.changePassword($event)
      }
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.deleteAccount($event)
      }
    }
  }, [_vm._v("Delete Account")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-dialog', {
    ref: "deleteAccountDialog"
  }, [_c('md-dialog-title', [_vm._v("Delete Account")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      Are you sure to delete your account?"), _c('br'), _vm._v("\n      All your stored schemas would be lost!\n    ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.deleteAccountCanceled($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.deleteAccountConfirmed($event)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return menuData; });
var menuData = {
  menuItems: [{
    name: 'remove',
    label: 'Remove',
    disabled: function disabled(source) {
      if (source.node.parent) {
        var schema = source.node.parent.schema;
        var required = false;
        if (schema) {
          if (schema.required) {
            required = schema.required.indexOf(source.node.name) >= 0;
          }
        }
        return required;
      } else {
        return true;
      }
    },
    action: function action(source) {
      source.remove();
    }
  }]
};

/* unused harmony default export */ var _unused_webpack_default_export = (menuData);

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RepositoryNotInitError */
/* unused harmony export SchemaNotExistError */
/* unused harmony export Repository */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return repository; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__firebase_index__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_json_schema_ref_parser__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_json_schema_ref_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_json_schema_ref_parser__);











function RepositoryNotInitError(message) {
  this.name = 'RepositoryNotInitError';
  this.message = message || 'Repository has not initialized.';
  this.stack = new Error().stack;
}
RepositoryNotInitError.prototype = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(Error.prototype);
RepositoryNotInitError.prototype.constructor = RepositoryNotInitError;

function SchemaNotExistError(message) {
  this.name = 'SchemaNotExistError';
  this.message = message || 'Schema not exist.';
  this.stack = new Error().stack;
}
SchemaNotExistError.prototype = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(Error.prototype);
SchemaNotExistError.prototype.constructor = SchemaNotExistError;

function EncodeSchema(schema) {
  var result = Array.isArray(schema) ? [] : {};
  for (var prop in schema) {
    var value = schema[prop];
    if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) === 'object') {
      result[encodeURIComponent(prop).replace('.', '%2E')] = EncodeSchema(value);
    } else {
      result[encodeURIComponent(prop).replace('.', '%2E')] = value;
    }
  }
  return result;
}

function DecodeSchema(schema) {
  var result = Array.isArray(schema) ? [] : {};
  for (var prop in schema) {
    var value = schema[prop];
    if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) === 'object') {
      result[decodeURIComponent(prop.replace('%2E', '.'))] = DecodeSchema(value);
    } else {
      result[decodeURIComponent(prop.replace('%2E', '.'))] = value;
    }
  }
  return result;
}

var Repository = function () {
  function Repository() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Repository);

    this.database = new __WEBPACK_IMPORTED_MODULE_8__firebase_index__["b" /* Database */]();
    this.uid = null;

    this.firebaseResolver = {
      order: 1,
      canRead: /^firebase:/i,
      read: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(file) {
          var schemaName;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  schemaName = file.url.substr(11);
                  _context.next = 3;
                  return _this.retrieveSchema(schemaName, false);

                case 3:
                  return _context.abrupt('return', _context.sent);

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function read(_x) {
          return _ref.apply(this, arguments);
        };
      }()
    };
    this.resolvers = { firebase: this.firebaseResolver };
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Repository, [{
    key: 'init',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  if (__WEBPACK_IMPORTED_MODULE_7_firebase__["auth"]().currentUser) {
                    _this2.uid = __WEBPACK_IMPORTED_MODULE_7_firebase__["auth"]().currentUser.uid;
                    resolve();
                  } else {
                    reject(new __WEBPACK_IMPORTED_MODULE_8__firebase_index__["c" /* UserNotSignInError */]());
                  }
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _ref2.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: 'retrieveSchema',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(schemaName, dereference) {
        var reference, schema;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.uid) {
                  _context3.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                schemaName = encodeURIComponent(schemaName).replace('.', '%2E');
                reference = '/schemas/' + this.uid + '/' + schemaName;
                _context3.next = 6;
                return this.database.readValue(reference);

              case 6:
                schema = _context3.sent;

                if (!schema) {
                  _context3.next = 21;
                  break;
                }

                schema = DecodeSchema(schema);

                if (!(dereference || typeof dereference === 'undefined')) {
                  _context3.next = 18;
                  break;
                }

                _context3.prev = 10;
                _context3.next = 13;
                return __WEBPACK_IMPORTED_MODULE_9_json_schema_ref_parser___default.a.bundle(schema, { resolve: this.resolvers });

              case 13:
                return _context3.abrupt('return', _context3.sent);

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](10);

              case 18:
                return _context3.abrupt('return', schema);

              case 21:
                throw new SchemaNotExistError();

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[10, 16]]);
      }));

      function retrieveSchema(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return retrieveSchema;
    }()
  }, {
    key: 'retrieveAllSchemas',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var reference, queryResult, schemas;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.uid) {
                  _context4.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                reference = '/schemas/' + this.uid;
                _context4.next = 5;
                return this.database.readSnapshot(reference);

              case 5:
                queryResult = _context4.sent;
                schemas = [];

                queryResult.forEach(function (item) {
                  schemas.push(DecodeSchema(item.val()));
                });
                return _context4.abrupt('return', schemas);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function retrieveAllSchemas() {
        return _ref4.apply(this, arguments);
      }

      return retrieveAllSchemas;
    }()
  }, {
    key: 'retrieveTypes',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var reference, types;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.uid) {
                  _context5.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                reference = '/schemas/' + this.uid;
                _context5.next = 5;
                return this.database.list(reference);

              case 5:
                types = _context5.sent;
                return _context5.abrupt('return', types);

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function retrieveTypes() {
        return _ref5.apply(this, arguments);
      }

      return retrieveTypes;
    }()
  }, {
    key: 'saveSchema',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(schema, schemaName) {
        var reference;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.uid) {
                  _context6.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                schemaName = encodeURIComponent(schemaName).replace('.', '%2E');
                reference = '/schemas/' + this.uid + '/' + schemaName;
                _context6.next = 6;
                return this.database.write(reference, EncodeSchema(schema));

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function saveSchema(_x4, _x5) {
        return _ref6.apply(this, arguments);
      }

      return saveSchema;
    }()
  }, {
    key: 'deleteSchema',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(schemaName) {
        var reference;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.uid) {
                  _context7.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                schemaName = encodeURIComponent(schemaName).replace('.', '%2E');
                reference = '/schemas/' + this.uid + '/' + schemaName;
                _context7.next = 6;
                return this.database.delete(reference);

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteSchema(_x6) {
        return _ref7.apply(this, arguments);
      }

      return deleteSchema;
    }()
  }, {
    key: 'deleteAllSchemas',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var reference;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.uid) {
                  _context8.next = 2;
                  break;
                }

                throw new RepositoryNotInitError();

              case 2:
                reference = '/schemas/' + this.uid;
                _context8.next = 5;
                return this.database.delete(reference);

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deleteAllSchemas() {
        return _ref8.apply(this, arguments);
      }

      return deleteAllSchemas;
    }()
  }]);

  return Repository;
}();

var repository = new Repository();

/* unused harmony default export */ var _unused_webpack_default_export = (repository);

/***/ })

},[435]);


// WEBPACK FOOTER //
// static/js/nav.eb5269e346ee616745af.js